import { useState, useEffect } from 'react';
import { marketplaceService } from '../services/marketplaceService';

interface MarketplaceStatus {
  isEnabled: boolean;
  disabledReason?: string;
}

export const useMarketplaceStatus = () => {
  const [status, setStatus] = useState<MarketplaceStatus>({ isEnabled: true });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkMarketplaceStatus = async () => {
      try {
        setLoading(true);
        setError(null);
        const marketplaceStatus = await marketplaceService.getMarketplaceStatus();
        setStatus(marketplaceStatus);
      } catch (err) {
        console.error('Error checking marketplace status:', err);
        setError(err instanceof Error ? err.message : 'Failed to check marketplace status');
        // Default to disabled if there's an error
        setStatus({ isEnabled: false, disabledReason: 'Service unavailable' });
      } finally {
        setLoading(false);
      }
    };

    checkMarketplaceStatus();
  }, []);

  const refresh = async () => {
    try {
      setError(null);
      const marketplaceStatus = await marketplaceService.getMarketplaceStatus();
      setStatus(marketplaceStatus);
    } catch (err) {
      console.error('Error refreshing marketplace status:', err);
      setError(err instanceof Error ? err.message : 'Failed to refresh marketplace status');
      setStatus({ isEnabled: false, disabledReason: 'Service unavailable' });
    }
  };

  return {
    isEnabled: status.isEnabled,
    disabledReason: status.disabledReason,
    loading,
    error,
    refresh,
  };
};